var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 94C37.6111 94 36.4306 93.514 35.4583 92.5417C34.4861 91.5695 34 90.389 34 89V52.75C34 51.3611 34.4861 50.1806 35.4583 49.2083C36.4306 48.2361 37.6111 47.7499 39 47.7499H47.75V39C47.75 37.6111 48.2362 36.4306 49.2083 35.4583C50.1805 34.4861 51.3612 34 52.75 34H75.25C76.6388 34 77.8195 34.4861 78.7917 35.4583C79.7638 36.4306 80.25 37.6111 80.25 39V61.5H89C90.3888 61.5 91.5695 61.9861 92.5417 62.9583C93.5138 63.9306 94 65.1111 94 66.5V89C94 90.389 93.5138 91.5695 92.5417 92.5417C91.5695 93.514 90.3888 94 89 94H68.4167V80.25H59.5833V94H39ZM39 89H47.75V80.25H39V89ZM39 75.25H47.75V66.5H39V75.25ZM39 61.5H47.75V52.75H39V61.5ZM52.75 75.25H61.5V66.5H52.75V75.25ZM52.75 61.5H61.5V52.75H52.75V61.5ZM52.75 47.7499H61.5V39H52.75V47.7499ZM66.5 75.25H75.25V66.5H66.5V75.25ZM66.5 61.5H75.25V52.75H66.5V61.5ZM66.5 47.7499H75.25V39H66.5V47.7499ZM80.25 89H89V80.25H80.25V89ZM80.25 75.25H89V66.5H80.25V75.25Z",
    fill: "#8993AF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3154,
    y: 17.1154,
    width: 93,
    height: 93,
    rx: 46.5,
    stroke: "#FC7013"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4707_41264",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4707_41264",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADGklEQVR4nO2dv4tTQRDHVyxExB/ZiZfm7MRCBAUb/SfERhsLrQSRZDaXQuxsFMFKwVKwvkJtbeRAxcZG1EqQqy0OD0XI7sjKno/jQMPlvbwfk7zvB9Jdcpv9ZF92ZmfyjAEAAAAAAAAAAACYG+Kod0CGNBKmd8HZH4HtL3H0MTi6F0e9pabH1yrGfPRMYFoXR/F/j+BoMzBdaHqcrcBz53ya8EkytqUw/RZnrzY93oXGTykDUhTKgBSFMiBFoQxIUSgDUhTKgBSFMnbEKYI4RZGQTMomInptUpju5hlT6/HVS/nQ+knWJCWw/Zl7QMAYP+ieDY42Kvge2cD86lopb4uOZ+GIfbvcuBS2rpp3N2f4oT2XnVncaSyV4uhrHC7vN23HZzJ2bD1rl5KeOx4eOW3ajp/w5RycvV/Wa00jI30oTNvxu0xgHVIgI+fEVSkFMgp/isuXAhmzHruWKAUyStsJzS4FMkqPFYpLgYwJccbMUgrGKelh2o6v6ti1wEppPb7yY1dIaXxlCKTolSFYKfpkCKTokyGQok/GdhlPgUOuhcMrkYEUuoEMVXisDD14yNADZCgCMhQBGYqADEVAhiIgQxGQoQjIUARkKAIyFAEZioAMRUCGIiBDEZChCMhQBGQoIlVlCNtXge2Xvz8K2VBBAqPw+V85tzqHA9sHkKGIeMnsDc5+w8pQhLBdw2VKEcL0DEVsighMT1FRqIjg6CF2U4pIPXuotVWEOMsofFaEOLqCoE8R40HnFCLwmog3D9I0fyfOPkc6pGJi//i+dNeZaRtZYt+eFNe5LEw3hO3t1HYc2D4Ojp4I2xcp/4Xc1AwEpotldhdFY/YEpkdIFBZEHK2W3fIVV7onkLUtQOzbQ9ldykrtw8tWyXek0HMibK9V1Rwpzr5Hg2VuIfSyqo7VuNI5VvS5rSTdciEwBbQRz1kqBL3dNSFMb9Bwr4h0H9hcRQdM69NG9KAAwdHn3SVsbYlXU/CYIvoi/wfMuuVNZT9bl7Pu9RSnYELrlsL0Kbt8vRZn+3Gw1KtzDAAAAAAAAAAAAACmNv4AHxR2CxZqDk4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanylogo);
export default __webpack_public_path__ + "static/media/Company logo.9c985bf752880f217511a3b88964a41e.svg";
export { ForwardRef as ReactComponent };